module.exports = __webpack_public_path__ + "static/img/img4.8fb4643.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/img4.png
// module id = lUKc
// module chunks = 1